import Vue from "vue";
import firebase from "firebase";
import { UserModule, store } from "@/store";
import { getModule } from "vuex-module-decorators";
import { UserDb } from "@/models/User";
import ProcessoModel, { ProcessoDados } from "@/models/Processo";
import ChatModel, { ChatDados } from "@/models/Chat";
import SingleChatController from "@/components/Chat/SingleChatController";
import EventBus, { DeclaredEvents, SnackBarEvent, SnackPriorityToColor } from "@/EventBus";
import _debug from "debug";

const debug = _debug("Mediacao:MainChatsController");

const userModule = getModule(UserModule, store);

export default class MainChatsController {
    private meusProcessos: Set<ProcessoModel> = new Set();
    private meusChats: Set<ChatModel> = new Set();
    private chatControllers: Map<string, SingleChatController> = new Map();

    constructor() {
        debug("Chat Controller criado");
    }

    public async watchChats() {
        const user = userModule.getUser;
        debug("MainChatsController.watchChats", user);
        if (user && user.userDb) {
            firebase
                .firestore()
                .collection("processos")
                .where(
                    "userParteUm",
                    "==",
                    firebase
                        .firestore()
                        .collection("users")
                        .doc(user.userDb.email),
                )
                .onSnapshot(processoDoc => {
                    debug("onSnapShot userParteUm");
                    this.newProcesso(processoDoc.docs, user);
                });

            firebase
                .firestore()
                .collection("processos")
                .where(
                    "userParteDois",
                    "==",
                    firebase
                        .firestore()
                        .collection("users")
                        .doc(user.userDb.email),
                )
                .onSnapshot(processoDoc => {
                    debug("onSnapShot userParteUm");
                    this.newProcesso(processoDoc.docs, user);
                });

            if (user.hasRoleOf(["mediador", "admin"])) {
                firebase
                    .firestore()
                    .collection("processos")
                    .where(
                        "userMediador",
                        "==",
                        firebase
                            .firestore()
                            .collection("users")
                            .doc(user.userDb.email),
                    )
                    .onSnapshot(processoDoc => {
                        debug("onSnapShot userParteUm");
                        this.newProcesso(processoDoc.docs, user.userDb);
                    });
            }
        }
    }

    public async newProcesso(processoDocs: firebase.firestore.DocumentSnapshot[], user: UserDb | undefined) {
        processoDocs.forEach(processoDoc => {
            const processo = ProcessoModel.fromQuerySnapshot(processoDoc, true);
            debug("");
            if (!this.meusProcessos.has(processo) && user) {
                if (processo.fazParte(user)) {
                    this.meusProcessos.add(processo);
                    this.listenToChats(processo);
                }
            }
        });
    }

    public getSingleChatControllerById(id: string) {
        if (this.chatControllers.has(id)) {
            return this.chatControllers.get(id);
        }
        return null;
    }

    public closeAll(): void {
        this.chatControllers.forEach(singleChatController => {
            singleChatController.close();
        });
        this.chatControllers.clear();
        this.meusChats.clear();
        this.meusProcessos.clear();
    }

    private async listenToChats(processo: ProcessoModel) {
        firebase
            .firestore()
            .collection(`processos/${processo.id}/chatsProcesso`)
            .onSnapshot(chatsSnapshot => {
                chatsSnapshot.docs.forEach(chatDoc => {
                    const dados: unknown = Object.assign({ id: chatDoc.id }, chatDoc.data());
                    const chat = new ChatModel(dados as ChatDados, null, processo);
                    this.addChat(chat);
                });
            });
    }
    private async addChat(chat: ChatModel) {
        if (!this.meusChats.has(chat)) {
            this.meusChats.add(chat);
            this.listenToChatMessages(chat);
        }
    }
    private async listenToChatMessages(chat: ChatModel) {
        debug("listenToChatMessages", chat);
        const chatController: SingleChatController = new SingleChatController(chat);
        this.chatControllers.set(chat.id as string, chatController);
        EventBus.$emit(DeclaredEvents.singleChatControllerDisponivel, chatController);
        if (chat.status === "aberto" && chat.processo) {
            chatController.startListeningToDatabase();
            const event: SnackBarEvent = {
                message: "Você tem um chat acontecendo agora",
                priority: SnackPriorityToColor.success,
                actionButtonText: "Ir para o Chat",
                actionButtonRoute: `/processo/${chat.processo.id}/chat/${chat.id}`,
            };
            EventBus.$emit(DeclaredEvents.snackBarMessage, event);
        } else {
            chatController.loadMessagesFromDatabase();
        }
    }
}
